import React from 'react';
import { url } from '../helpers/helpers';

const userContext = React.createContext();

function getUserFromLocalStorage(){
    try {
        return localStorage.getItem('users') ? JSON.parse(localStorage.getItem('users')) : null
    } catch (e) {
        return null
    }
}

function UserContext(props){
    const [user,setUser] = React.useState(getUserFromLocalStorage());
    const [load,setLoad] = React.useState(false);

    React.useEffect(()=>{
        localStorage.setItem('users',JSON.stringify(user))
    },[user])

    // A failed server call stops the loading spinner (see helpers/sessionGuard.js).
    React.useEffect(()=>{
        const stop = () => setLoad(false)
        window.addEventListener('api-error', stop)
        return () => window.removeEventListener('api-error', stop)
    },[])

    // Reload company settings when the app opens, so changes made by the super admin
    // apply without logging in again.
    const token = user && user.token;
    React.useEffect(()=>{
        if (!token) return;
        fetch(url + 'my-settings', { headers: { 'Authorization': token } })
            .then(response => response.ok ? response.json() : null)
            .then(data => {
                if (data && data.status === 200) {
                    setUser(current => current ? { ...current, ...data.company, settings: data.settings, role: data.role, subscription: data.subscription, impersonated_by: data.impersonated_by, must_change_password: data.must_change_password, two_factor: data.two_factor } : current)
                }
            })
            .catch(() => {})
    },[token])

    return (
        <userContext.Provider value={{user,setUser,load,setLoad}} >
            {props.children}
        </userContext.Provider>
    )
}

export {userContext,UserContext}
